import React from 'react';

import OtherOrgUnitContextProvider from './state/otherOrgOrgUnit/OtherOrgUnitContextProvider';

import TeamStaffRolesContextProvider from './state/teamStaffRoles/TeamStaffRolesContextProvider';

import CourseContextProvider from '@usas/ui-web/state/course/CourseContextProvider';
import MeetClassificationContextProvider from '@usas/ui-web/state/meet/meetClassification/MeetClassificationContextProvider';
import MeetClassificationTypeContextProvider from '@usas/ui-web/state/meet/meetClassificationType/MeetClassificationTypeContextProvider';
import MeetSoftwareContextProvider from '@usas/ui-web/state/meet/meetSoftware/MeetSoftwareContextProvider';
import ClubAffiliationTypeContextProvider from '@usas/ui-web/state/clubAffiliationType/ClubAffiliationTypeContextProvider';
import ReportPeriodFlatContextProvider from '@usas/ui-web/state/reportPeriodFlat/ReportPeriodFlatContextProvider';
import PoolDimensionsContextProvider from '@usas/ui-web/state/poolDimensions/PoolDimensionsContextProvider';
import ReportPeriodContextProvider from '@usas/ui-web/state/reportPeriod/ReportPeriodContextProvider';
import CompetitionGenderTypeContextProvider from '@usas/ui-web/state/competitionGender/CompetitionGenderTypeContextProvider';

const AppStateContextProviders = ({ children }) => (
  <OtherOrgUnitContextProvider>
    <PoolDimensionsContextProvider>
      <CourseContextProvider>
        <MeetClassificationContextProvider>
          <MeetClassificationTypeContextProvider>
            <MeetSoftwareContextProvider>
              <ClubAffiliationTypeContextProvider>
                <ReportPeriodContextProvider>
                  <ReportPeriodFlatContextProvider>
                    <TeamStaffRolesContextProvider>
                      <CompetitionGenderTypeContextProvider>
                        {children}
                      </CompetitionGenderTypeContextProvider>
                    </TeamStaffRolesContextProvider>
                  </ReportPeriodFlatContextProvider>
                </ReportPeriodContextProvider>
              </ClubAffiliationTypeContextProvider>
            </MeetSoftwareContextProvider>
          </MeetClassificationTypeContextProvider>
        </MeetClassificationContextProvider>
      </CourseContextProvider>
    </PoolDimensionsContextProvider>
  </OtherOrgUnitContextProvider>
);

export default AppStateContextProviders;